module.exports = __webpack_public_path__ + "img/trial2-1.463d8753.png";